import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VerticalStepperService {

  private selectedIndexSubject$ = new BehaviorSubject<number>(0);
  selectedIndexObservable$ = this.selectedIndexSubject$.asObservable();
  setSelectedIndex(index: number){
    this.selectedIndexSubject$.next(index);
  }
}
